import React, { useState, useEffect, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AlertModal from "web/components/AlertModal";
import { Table } from "reactstrap";
import { TableSection } from "../myOrderStyled";
import { downloadFile } from 'redux/actions/helper/downloadFile';
import * as moment from "moment";
import ConfirmationModal from "web/components/ConfirmationModal";
import BolUploadModal from "web/components/BolUploadModal";
import PickupDetailsModal from "web/pages/private/CommonPages/MyPickupOrders/PopUpModals/PickupDetailsModal";
import { AiOutlineArrowDown, AiOutlineArrowUp, AiOutlineVerticalAlignMiddle } from "react-icons/ai";
import { stateConvert } from "web/components/utils/stateAbbreviation";
import { deliveryReqOrderDeclineApi } from "redux/actions/myPickupOrders"
import { pickupOrderDeclineApi } from "redux/actions/myPickupOrders"
import { orderUpdate, downloadOrderById } from "redux/actions/myOrders";
import WithdrawIcon from "web/assets/images/withdraw-icon.png";
import DownloadIcon from "web/assets/svg/DownloadInvoiceIcon";
import { palletTypeOptions } from '../Constants'
import Tooltip from "@material-ui/core/Tooltip";

function ScheduledPostsTable(props) {
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem('token');
  const sortState = props?.scheduledPostsSortState
  const [accordionOpenIndex, setAccordionOpenIndex] = useState()
  const [selectedOrderDetails, setSelectedOrderDetails] = useState();

  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  const [alertType, setAlertType] = useState();
  const [modalResult, setModalResult] = useState("");
  const toggleModal = () => setAlertModal(!alertModal);

  const [confirmationComment, setConfirmationComment] = useState("");
  const [yesNomodal, setYesNoModal] = useState(false);
  const [yesNoModalContent, setYesNoModalContent] = useState("");
  const [yesNoModalAlertType, setYesNoModalAlertType] = useState();

  const [pickupDetailsModalIsOpen, setPickupDetailsModalIsOpen] = useState(false)

  const [modalBOL, setModalBOL] = useState(false);
  const toggleBOLModal = () => setModalBOL(!modalBOL);

  const headerArray = [
    { title: 'Req. Del/Pickup Date', sort: true, sortColumn: 'RDD' },
    { title: 'PO Number' },
    { title: 'Order Number' },
    { title: 'Location', sort: true, sortColumn: 'LOCATION_NAME' },
    { title: 'Type' },
    { title: 'Qty, Order Type' },
    { title: "Status", align: 'center' },
  ]

  const orderType = (items) => {
    let totalQuantity = items?.quantityDetails?.totalQuantity
    let condition
    if (items?.palletDetails?.condition?.length !== 1) {
      condition = items?.palletDetails?.condition?.join(", ")
    } else {
      if (items?.palletDetails?.condition.length !== 0)
        condition = items?.palletDetails?.condition
    }

    let palletType;
    let size = "";
    let grade = "";
    let LWH
    let heatTreated = ''
    if (items?.palletDetails?.material !== "WOOD") {
      const length = items?.palletDetails?.length
      const width = items?.palletDetails?.width
      const height = items?.palletDetails?.height
      LWH = length + "x" + width + "x" + height
      if (condition) {
        condition = condition?.toString()
        condition = condition?.toLowerCase();
        condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

        return totalQuantity + ", " + LWH + "-" + condition
      } else {
        return totalQuantity + ", " + LWH
      }

    } else {
      palletType = items?.palletDetails?.palletType

      if (items?.palletDetails?.size) {
        if (items?.palletDetails?.size === 'Custom') {
          const length = items?.palletDetails?.length
          const width = items?.palletDetails?.width
          const height = items?.palletDetails?.height
          size = ", " + length + "x" + width + "x" + height
        } else {
          size = ", " + items?.palletDetails?.size
        }
      }

      if (items?.palletDetails?.grade) grade = items?.palletDetails?.grade + ', '

      palletType = palletType?.toLowerCase();
      palletType = palletType?.replace(/\b\w/g, c => c.toUpperCase())
      condition = condition?.toString()
      condition = condition?.toLowerCase();
      condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

      if (items?.palletDetails?.newConditionType) {
        let newConditionType
        if (items?.palletDetails?.newConditionType === 'HARDWOOD') newConditionType = '(HW)'
        else if (items?.palletDetails?.newConditionType === 'SOFTWOOD') newConditionType = '(SW)'
        if (newConditionType) condition = `${condition} ${newConditionType}`
      }

      if (items?.palletDetails?.heatTreared) heatTreated = ', HT'

      return (
        <>
          <p style={{ margin: '0px', whiteSpace: 'nowrap' }}>{totalQuantity + "" + size}</p>
          <p style={{ margin: '0px', whiteSpace: 'nowrap' }}>{grade + palletType + "-" + condition + heatTreated}</p>
        </>
      )
    }
  }

  const displayPickupDetails = (items) => {
    let totalQuantity = items?.quantityDetails?.totalQuantity
    const palletList = items?.pickupOrder?.pickedupDetails?.palletList
    if (['PICKEDUP', 'COMPLETE'].includes(items?.orderStatus) && palletList) {
      const getLabelFromValue = (value) => {
        const option = palletTypeOptions.find(option => option.value === value);
        return option ? option.label : '';
      };
      let pickedUpDetailsString = palletList?.map((data, index) => (
        `${data?.qty} ${getLabelFromValue(data?.palletType)}`
      ))
      return pickedUpDetailsString?.join(', ')
    } else {
      return totalQuantity + ', NA'
    }
  }

  const callOrderPageFunc = (items) => {
    if (items?.requestType === 'PickUp') {
      let value = 0
      if (items.orderStatus?.includes('PENDING')) return
      else if (items.orderStatus?.includes('ASSIGNED') || items.orderStatus?.includes('RESCHEDULED')) value = 1
      else if (items.orderStatus?.includes('PICKEDUP') || items.orderStatus?.includes('HOLD')) value = 2
      else if (items.orderStatus?.includes('COMPLETE')) value = 3
      else if (items.orderStatus?.includes('CANCELLED')) value = 4
      else if (items.orderStatus?.includes('CLAIM')) value = 5
      localStorage.setItem('redirectPickupOrderTabValue', value)
      localStorage.setItem('redirectedOrderValue', (items?.orderNo || items?.orderRefNumber || ''))
      history.push('/my-pickup-orders')
    } else if (items.orderStatus?.includes('REQUESTED') || items.orderStatus?.includes('POSTED')) {
      history.push('./my-posted-pallet-needs')
    } else {
      let value = 0
      if (items.orderStatus?.includes('ASSIGNED') || items.orderStatus?.includes('RESCHEDULED') || items.orderStatus?.includes('SHIPPED')) value = 1
      else if (items.orderStatus?.includes('DELIVERED')) value = 2
      else if (items.orderStatus?.includes('COMPLETE')) value = 3
      else if (items.orderStatus?.includes('CANCELLED')) value = 4
      else if (items.orderStatus?.includes('CLAIM')) value = 5
      localStorage.setItem('manageOrderTabFromPtPlusScheduledPost', value)
      localStorage.setItem('redirectedOrderValue', (items?.orderNo || items?.orderRefNumber || ''))
      let myOrderSelectedPageObj = { myOrderSelectedPage: 1, }
      dispatch({ type: 'MYORDER_PAGINATION', payload: myOrderSelectedPageObj })
      history.push('./my-orders')
    }
  }

  const setSortStateFunction = (column, value) => {
    let nextType
    if (value === 'normal') nextType = 'ASC'
    else if (value === 'ASC') nextType = 'DESC'
    else if (value === 'DESC') nextType = 'normal'

    let newSortState = {
      sortColumn: column,
      sortValue: nextType
    }
    props.fetchDataCallBack(newSortState, 'sortingChange')
  }

  const sortIconStyle = {
    height: '22px',
    width: '28px',
    color: '#61b01f'
  }

  const getStatusClassName = (items) => {
    let isRedBgRequired = false
    if (items?.orderStatus === 'ASSIGNED' || items?.orderStatus === 'PENDING' || items?.orderStatus === 'SHIPPED') isRedBgRequired = true
    let requestedDate = items?.requestType === 'PickUp' ? items.requestDeliveryDate
      : items?.ptPostedDetailsDTO ? items?.ptPostedDetailsDTO?.requestDeliveryDate
        : items.requestDeliveryDate
    if (isRedBgRequired && requestedDate && moment(requestedDate).isBefore(moment(), 'day')) return "EXPIRED";
    return items?.orderStatus;
  }

  const withdrawRequestOrderConfirmation = (items) => {
    setYesNoModalContent(items?.requestType === 'PickUp' ? 'Are you sure you want to withdraw the pickup order request?' : 'Are you sure you want to withdraw the order request?');
    setYesNoModalAlertType(items?.requestType === 'PickUp' ? 'withdrawPickupRequestOrder' : 'withdrawRequestOrder')
    setYesNoModal(true);
  }

  const withdrawRequestOrderFunction = async (confirmationAlertType) => {
    let data = {
      locationId: null,
      tenderId: selectedOrderDetails?.tenderId,
      comment: confirmationComment ?? null,
      tenderStatus: 'WITHDRAW'
    }
    let response
    if (selectedOrderDetails?.requestType === 'PickUp') {
      response = await dispatch(pickupOrderDeclineApi(data, token));
    } else {
      response = await dispatch(deliveryReqOrderDeclineApi(data, token));
    }
    if (response?.success) {
      setSelectedOrderDetails()
      setAlertModalContent(confirmationAlertType === 'withdrawPickupRequestOrder' ? 'Pickup order request withdrawn successfully!' : 'Order request withdrawn successfully!')
      setAlertType('success')
      toggleModal();
      setModalResult('successRefreshPage')
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setAlertModalContent(response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.');
        toggleModal();
      }
    }
  }

  const shipDeliverFunction = async (id, status, values) => {
    let data;
    let formData = new FormData();
    let response;
    if (status === "DELIVERED") {
      data = {
        orderId: id,
        shippingStatus: status,
        urlBill: ["url1", "url2"],
        fromDate: values.orderDeliveryDate,
        fromTime: values.orderDeliveryTime,
        requestFromPtplusUser: true
      };
      formData.append("request", JSON.stringify(data));
      formData.append("file", values.bolDocument);
      response = await dispatch(orderUpdate(formData, token));
    } else {
      data = {
        orderId: id,
        shippingStatus: status,
        requestFromPtplusUser: true
      };
      formData.append("request", JSON.stringify(data));
      response = await dispatch(orderUpdate(formData, token));
    }

    if (response.status === "SUCCESS") {
      setSelectedOrderDetails()
      setAlertType('success')
      setAlertModalContent(response.message);
      toggleModal();
      setModalResult('successRefreshPage')
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setAlertModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        toggleModal();
      }
    }
  };

  const downloadFiles = async (imagePath, type) => {
    if (type === 'multiple') {
      imagePath.forEach(val => dispatch(downloadFile(val.fileName)))
    } else {
      dispatch(downloadFile(imagePath));
    }
  };

  const downloadReceipt = async (id, location) => {
    let response = await dispatch(downloadOrderById(id, token, location));
    if (response.type === "application/json") {
      setAlertModalContent('Invoice is not generated yet, please try again after the payment is captured.');
      toggleModal();
    } else {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Download Receipt.pdf");
      document.body.appendChild(link);
      link.click();

    }
  };

  return (
    <TableSection>
      <Table responsive>
        <thead>
          <tr>
            {headerArray.map((items, index) => (
              <th key={index} style={{
                whiteSpace: items.sort ? 'nowrap' : 'normal',
                textAlign: items.align === 'center' ? 'center' : 'left'
              }}>
                {items.title}
                {items.sort && (() => {
                  const isDescending = sortState.sortColumn === items.sortColumn && sortState.sortValue === 'DESC';
                  const isAscending = sortState.sortColumn === items.sortColumn && sortState.sortValue === 'ASC';

                  if (isDescending) {
                    return <AiOutlineArrowDown onClick={() => setSortStateFunction(items.sortColumn, 'DESC')} style={sortIconStyle} />;
                  } else if (isAscending) {
                    return <AiOutlineArrowUp onClick={() => setSortStateFunction(items.sortColumn, 'ASC')} style={sortIconStyle} />;
                  } else {
                    return <AiOutlineVerticalAlignMiddle onClick={() => setSortStateFunction(items.sortColumn, 'normal')} style={sortIconStyle} />;
                  }
                })()}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.pagedata?.map((items, index) => (
            <>
              <tr key={0} className={accordionOpenIndex === index ? 'blue-bg' : ''}>
                <td>
                  {items?.requestType === 'PickUp' ?
                    <>{moment(items.requestDeliveryDate).format('MM/DD/YYYY')}</>
                    :
                    items?.ptPostedDetailsDTO ?
                      <>{moment(items?.ptPostedDetailsDTO?.requestDeliveryDate).format('MM/DD/YYYY')}</>
                      :
                      <>{moment(items.requestDeliveryDate).format('MM/DD/YYYY')}</>}
                </td>
                <td title={items.poNumber}>{items.poNumber && items.poNumber !== '' ? items.poNumber : 'NA'}</td>
                <td>{items.orderNo && items.orderNo !== '' ? items.orderNo : 'NA'}</td>
                <td>
                  <p style={{ margin: '0px', whiteSpace: 'nowrap' }}>{items?.ptPostedDetailsDTO && items?.ptPostedDetailsDTO?.shippingAddress ? `${items?.ptPostedDetailsDTO?.shippingAddress?.locationName}` : items.addressDTO && `${items.addressDTO.locationName}`}</p>
                  <p style={{ margin: '0px', whiteSpace: 'nowrap' }}>
                    {items?.ptPostedDetailsDTO && items?.ptPostedDetailsDTO?.shippingAddress ?
                      `${items?.ptPostedDetailsDTO?.shippingAddress?.street} - ${items?.ptPostedDetailsDTO?.shippingAddress?.city}, ${stateConvert(items?.ptPostedDetailsDTO?.shippingAddress?.state) || items?.ptPostedDetailsDTO?.shippingAddress?.state} `
                      :
                      items.addressDTO && `${items.addressDTO.street} - ${items.addressDTO.city}, ${stateConvert(items.addressDTO.state) || items.addressDTO.state} `}
                  </p>
                </td>
                <td>{items?.requestType === 'PickUp' ? 'Pickup' : 'Delivery'}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{items?.requestType === 'Delivery' ?
                  orderType(items)
                  :
                  displayPickupDetails(items)
                }</td>
                <td className='expand-collapse-class'>
                  {items?.orderStatus === 'PENDING' &&
                    <div>
                      <button
                        title="Withdraw Request"
                        className='withdraw-action-btn'
                        onClick={(e) => {
                          withdrawRequestOrderConfirmation(items)
                          setSelectedOrderDetails(items)
                        }}
                      >
                        <img src={WithdrawIcon} alt="withdraw" />
                      </button>
                    </div>
                  }
                  <div
                    className={`status-class ${getStatusClassName(items)}`}
                    onClick={() => {
                      callOrderPageFunc(items)
                    }}
                  >
                    <p>{items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus}</p>
                    {(items?.requestType === 'PickUp' && items.orderStatus?.includes('PENDING')) ? '' : <span>{`>`}</span>}
                  </div>
                  {(accordionOpenIndex === index) ? <h4 onClick={() => setAccordionOpenIndex()}><i></i></h4>
                    : <h5 onClick={() => setAccordionOpenIndex(index)}><i></i></h5>}
                </td>
              </tr>
              {accordionOpenIndex === index &&
                <>
                  <tr className='order-details-wrapper'>
                    <td colspan="1">
                      <div>
                        <h6>Customer Name</h6>
                        <p>{items.addressDTO?.name}</p>
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <h6>Ref No</h6>
                        <p style={{ whiteSpace: 'nowrap' }}>{items.orderRefNumber || 'NA'}</p>
                      </div>
                    </td>
                    <td colspan="1">
                      {items?.requestType === 'Delivery' ?
                        <div>
                          <h6>Customer Price</h6>
                          <p>{items?.requestType === 'Delivery' ?
                            (items?.flatFee) ? `$${Number(items?.flatFee)?.toFixed(2)}` : 'NA'
                            :
                            (items?.tenderDetails?.customerPrice && items?.tenderDetails?.customerPrice?.length >= 1 && items?.tenderDetails?.customerPrice[0]) ?
                              `$${Number(items?.tenderDetails?.customerPrice)?.toFixed(2)}` : 'NA'
                          }
                          </p>
                        </div>
                        :
                        <div>
                          <h6>Customer Price</h6>
                          <p>
                            {(['PICKEDUP', 'COMPLETE'].includes(items?.orderStatus) && items?.pickupOrder?.pickedupDetails?.palletList) ?
                              items?.pickupOrder?.pickedupDetails?.palletList?.map(data => `$${data?.customerPrice?.toFixed(2)}`)?.join(', ')
                              :
                              'NA'}
                          </p>
                        </div>
                      }
                    </td>
                    <td></td><td></td><td></td><td></td>
                  </tr>
                  <tr className='order-details-wrapper'>
                    <td colspan="1">
                      <div>
                        <h6>Supplier Name - City, ST</h6>
                        <p style={{ marginBottom: '0px', whiteSpace: 'nowrap' }}>{items?.tenderDetails ? `${items?.tenderDetails.postedTo}` : 'NA'}</p>
                        <p style={{ marginTop: '0px', whiteSpace: 'nowrap' }}>
                          {items?.tenderDetails && `${items?.tenderDetails.city}, ${stateConvert(items?.tenderDetails.state) || items?.tenderDetails.state}`}
                        </p>
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <h6>Supplier Email</h6>
                        <Tooltip
                          placement="top"
                          arrow
                          title={items?.tenderDetails?.email ? items?.tenderDetails?.email?.join(', ') : 'NA'}
                          enterTouchDelay={5}
                          leaveTouchDelay={10000}
                        >
                          <p style={{ whiteSpace: 'nowrap' }}>
                            {items?.tenderDetails?.email?.[0]
                              ? items.tenderDetails.email[0].length > 20 ? (items.tenderDetails.email[0].slice(0, 20) + '...') : items.tenderDetails.email[0]
                              : 'NA'}
                          </p>
                        </Tooltip>
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <h6 style={{ whiteSpace: 'nowrap' }}>Supplier Phone</h6>
                        <Tooltip
                          placement="top"
                          arrow
                          title={(items?.tenderDetails?.phoneNumber && items?.tenderDetails?.phoneNumber[0]) ? items?.tenderDetails?.phoneNumber?.join(', ') : 'NA'}
                          enterTouchDelay={5}
                          leaveTouchDelay={10000}
                        >
                          <p>{(items?.tenderDetails?.phoneNumber && items?.tenderDetails?.phoneNumber[0]) ? items?.tenderDetails?.phoneNumber[0] : 'NA'}</p>
                        </Tooltip>
                      </div>
                    </td>
                    <td colspan="1">
                      {items?.requestType === 'Delivery' ?
                        <div>
                          <h6>Supplier Price</h6>
                          {(items?.tenderDetails?.vendorPrice && items?.tenderDetails?.vendorPrice?.length >= 1 && items?.tenderDetails?.vendorPrice[0]) ?
                            <Tooltip
                              placement="top"
                              arrow
                              title={items?.tenderDetails?.vendorPrice?.map(price => `$${Number(price).toFixed(2)}`).join(', ')}
                              enterTouchDelay={5}
                              leaveTouchDelay={10000}
                            >
                              <p>{items?.tenderDetails?.vendorPrice?.length > 1 ? 'Multi' : items?.tenderDetails?.vendorPrice?.map(price => `$${Number(price).toFixed(2)}`).join(', ')}</p>
                            </Tooltip>
                            :
                            'NA'
                          }
                        </div>
                        :
                        <div>
                          <h6>Supplier Price</h6>
                          <p>{(['PICKEDUP', 'COMPLETE'].includes(items?.orderStatus) && items?.pickupOrder?.pickedupDetails?.palletList) ?
                            items?.pickupOrder?.pickedupDetails?.palletList?.map(data => `$${data?.vendorPrice?.toFixed(2)}`)?.join(', ')
                            :
                            'NA'}
                          </p>
                        </div>
                      }
                    </td>
                    <td colspan="1">
                      <div>
                        <h6>Tendered Date</h6>
                        <p>
                          {items?.tenderDetails?.tenderDate ? items?.tenderDetails?.tenderDate :
                            (moment(items?.createdAt * 1000).format('MM/DD/YYYY') || 'NA')}
                        </p>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr className='order-details-wrapper'>
                    <td>
                      <div>
                        <h6>Customer Invoice</h6>
                        <p onClick={() => (items.invoiceId && downloadFiles(`${items.invoiceId}.pdf`))} className={items.invoiceId ? "download-icon-wrapper" : ""}>
                          {(items.invoiceId) ? <DownloadIcon /> : 'NA'}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div>
                        <h6>{items?.requestType === 'Delivery' ? 'Signed POD' : 'Signed Sort Form'}</h6>
                        {items?.requestType === 'Delivery' ?
                          <p onClick={() => (items?.orderStatus !== 'ASSIGNED' && items.bol && downloadFiles(items.bol))} className={(items?.orderStatus !== 'ASSIGNED' && items.bol) ? "download-icon-wrapper" : ""}>
                            {(items?.orderStatus !== 'ASSIGNED' && items.bol) ? <DownloadIcon /> : 'NA'}
                          </p>
                          :
                          <p onClick={() => (items?.orderStatus !== 'ASSIGNED' && items.pickupOrder?.pickedupDetails?.uploadedDocs && downloadFiles(items.pickupOrder?.pickedupDetails?.uploadedDocs, 'multiple'))} className={(items?.orderStatus !== 'ASSIGNED' && items.pickupOrder?.pickedupDetails?.uploadedDocs) ? "download-icon-wrapper" : ""}>
                            {(items?.orderStatus !== 'ASSIGNED' && items.pickupOrder?.pickedupDetails?.uploadedDocs) ? <DownloadIcon /> : 'NA'}
                          </p>
                        }
                      </div>
                    </td>
                    <td>
                      <div>
                        <h6>Supplier Receipt</h6>
                        {items?.requestType === 'Delivery' ?
                          <p onClick={() => (items?.orderStatus === 'COMPLETE' && downloadReceipt(items.orderNo, items?.orderDetail?.sellerLocationId))} className={(items?.orderStatus === 'COMPLETE') ? "download-icon-wrapper" : ""}>
                            {(items?.orderStatus === 'COMPLETE') ? <DownloadIcon /> : 'NA'}
                          </p>
                          :
                          <p onClick={() => (items.pickupOrder?.invoiceDet?.sellerInvoiceId && downloadFiles(items.pickupOrder?.invoiceDet?.sellerInvoiceId))} className={items.pickupOrder?.invoiceDet?.sellerInvoiceId ? "download-icon-wrapper" : ""}>
                            {(items.pickupOrder?.invoiceDet?.sellerInvoiceId) ? <DownloadIcon /> : 'NA'}
                          </p>
                        }
                      </div>
                    </td>
                    <td></td><td></td><td></td>
                    <td className="shipment-actions">
                      {(items?.requestType === 'PickUp' && items.orderStatus === 'ASSIGNED') &&
                        <button
                          style={{ width: 'fit-content' }}
                          onClick={() => {
                            setSelectedOrderDetails({ ...items?.pickupOrder, sellerLocationId: items?.tenderDetails?.sellerLocationId })
                            setPickupDetailsModalIsOpen(true)
                          }}
                        >Upload Sort Form</button>}
                      {items?.requestType === 'Delivery' &&
                        <>
                          {items.orderStatus === 'ASSIGNED' && <button onClick={() => shipDeliverFunction(items.orderNo, 'SHIPPED')}>Ship</button>}
                          {items.orderStatus === 'SHIPPED' && <button onClick={() => {
                            setSelectedOrderDetails({ ...items?.orderDetail, orderNo: items.orderNo });
                            toggleBOLModal();
                          }}>Deliver</button>}
                        </>
                      }
                    </td>
                  </tr>
                </>
              }
            </>
          ))}
        </tbody>
      </Table>
      {props.pagedata && props.pagedata.length === 0 &&
        <div><p style={{ width: '100%', textAlign: 'center', position: 'relative', bottom: '40px' }}>No records found</p></div>
      }
      <AlertModal
        isOpen={alertModal}
        toggle={toggleModal}
        title=''
        content={alertModalContent}
        alertType={alertType}
        link=''
        callBackAlert={(val) => {
          if (modalResult === 'successRefreshPage') {
            setModalResult('')
            toggleModal()
            props.fetchDataCallBack('', 'refreshData')
          } else toggleModal()
        }}
      />
      <ConfirmationModal
        isOpen={yesNomodal}
        toggle={() => {
          setYesNoModal(!yesNomodal);
          setConfirmationComment("");
        }}
        onClickHander={(val) => {
          if (val === "no") {
          } else {
            if (yesNoModalAlertType === 'withdrawPickupRequestOrder' || yesNoModalAlertType === 'withdrawRequestOrder') {
              withdrawRequestOrderFunction(yesNoModalAlertType)
              setYesNoModal(!yesNomodal);
              setConfirmationComment('')
            }
          }
        }}
        showCommentText={true}
        content={yesNoModalContent}
        confirmationComment={confirmationComment}
        setconfirmationComment={setConfirmationComment}
      />
      <BolUploadModal
        isOpen={modalBOL}
        toggle={toggleBOLModal}
        callBackBOL={(document) => shipDeliverFunction(selectedOrderDetails.orderNo, "DELIVERED", document)}
        uploadType={'upload'}
        selectedItem={selectedOrderDetails}
      />
      {pickupDetailsModalIsOpen &&
        <PickupDetailsModal
          closeModal={() => setPickupDetailsModalIsOpen(false)}
          modalData={selectedOrderDetails}
          pickedupSuccessCallBack={() => {
            setSelectedOrderDetails()
            props.fetchDataCallBack('', 'refreshData')
          }}
          claimRaisedSuccessCallBack={() => {
            localStorage.setItem('redirectPickupOrderTabValue', 5)
            localStorage.setItem('redirectedOrderValue', (selectedOrderDetails?.orderNo || ''))
            setSelectedOrderDetails()
            history.push('/my-pickup-orders')
          }}
        />
      }
    </TableSection>
  )
}

export default ScheduledPostsTable